import AvatarDropdownItem from './AvatarDropdownItem';

export default AvatarDropdownItem;
